export default __webpack_public_path__ + "static/media/bg_governance.45b31bff.png";